import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { dmChuyenNganh } from '../../services/chuyen-nganh/ChuyenNganhModels';

interface ChuyenNganhState {
    listData: dmChuyenNganh[];
    selectedId: number | null;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
}

const initialState: ChuyenNganhState = {
    listData: [],
    selectedId: null,
    status: 'idle'
};

const chuyenNganhSlice = createSlice({
    name: 'chuyenNganh',
    initialState,
    reducers: {
        setChuyenNganhList: (state, action: PayloadAction<dmChuyenNganh[]>) => {
            state.listData = action.payload;
        },
        setChuyenNganhStatus: (state, action: PayloadAction<ChuyenNganhState['status']>) => {
            state.status = action.payload;
        },
        setChuyenNganhSelectedId: (state, action: PayloadAction<number | null>) => {
            state.selectedId = action.payload;
        },
        clearChuyenNganh: (state) => {
            state.listData = [];
            state.selectedId = null;
            state.status = 'idle';
        }
    }
});

export const { setChuyenNganhList, setChuyenNganhStatus, setChuyenNganhSelectedId, clearChuyenNganh } =
    chuyenNganhSlice.actions;

export const ChuyenNganhReducer = chuyenNganhSlice.reducer;
